import { Link } from "react-router-dom";
import { categories } from "@/mocks/manga";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="mx-auto px-4 md:px-6 py-12 md:py-16 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex items-center justify-center w-9 h-9 rounded-full bg-primary-500 text-background-50">
                <i className="ri-book-open-fill text-lg"></i>
              </span>
              <span className="font-heading text-2xl text-primary-600">91漫画</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              海量免费漫画在线阅读平台，分类浏览+人气榜、热门推荐、完结榜、新作一网打尽，帮你快速找到想看的漫画。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">漫画分类</h4>
            <ul className="grid grid-cols-2 gap-2">
              {categories.slice(0, 8).map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {c.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-600">首页</Link></li>
              <li><Link to="/category/hot" className="text-sm text-foreground-600 hover:text-primary-600">人气榜</Link></li>
              <li><Link to="/category/completed" className="text-sm text-foreground-600 hover:text-primary-600">完结榜</Link></li>
              <li><Link to="/category/new" className="text-sm text-foreground-600 hover:text-primary-600">新作</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-3">热门漫画</h4>
            <ul className="space-y-2">
              {["烈火拳师", "剑与魔导", "灌篮之星", "都市奇缘", "深渊探险家"].map((t, i) => (
                <li key={t}>
                  <Link
                    to={`/article/${i + 1}`}
                    className="text-sm text-foreground-600 hover:text-primary-600"
                  >
                    {t}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">© {new Date().getFullYear()} 91漫画 版权所有 · 本站漫画仅作阅读分享</p>
          <p className="text-xs text-foreground-500">91漫画 · 人气榜 · 热门推荐 · 完结榜 · 新作</p>
        </div>
      </div>
    </footer>
  );
}